import { motion } from "framer-motion";
import { COIN_HERO } from "../../lib/tones";


export function CoinFlip({ value, fast }: { value: "HEADS" | "TAILS"; fast: boolean }) {
  const target = (fast ? 0 : 1800) + (value === "TAILS" ? 180 : 0);
  return (
    <div className="h-44 w-44 sm:h-48 sm:w-48" style={{ perspective: 900 }} data-testid="coin-flip-anim">
      <motion.div
        className="relative h-full w-full"
        style={{ transformStyle: "preserve-3d" }}
        initial={{ rotateY: 0, y: 0 }}
        animate={{ rotateY: target, y: fast ? 0 : [0, -60, 0] }}
        transition={{ duration: fast ? 0 : 0.85, ease: [0.2, 0.8, 0.3, 1] }}
      >
        <img src={COIN_HERO} alt="Heads" className="absolute inset-0 h-full w-full rounded-full object-cover [mask-image:radial-gradient(circle,black_58%,transparent_70%)]" style={{ backfaceVisibility: "hidden" }} />
        <div className="absolute inset-0" style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}>
          <img src={COIN_HERO} alt="Tails" className="h-full w-full rounded-full object-cover saturate-50 brightness-110 [mask-image:radial-gradient(circle,black_58%,transparent_70%)]" />
          <span className="ua-logo absolute inset-0 flex items-center justify-center text-6xl">T</span>
        </div>
      </motion.div>
    </div>
  );
}
